export enum BU_CHOICE {
  RENTENSTEIGERUNG = 'rentensteigerung',
  BEITRAGSDYNAMIK = 'beitragsdynamik',
  UEBERSCHUSSSYSTEM = 'buUeberschusssystem',
  BILDUNGSABSCHLUSS = 'bildungsabschluss',
  NICHTRAUCHER = 'nichtraucher',
  KARENZZEIT = 'karenzzeit',
  WERTEENTWICKLUNG = 'angenommeneWertentwicklung',
}

export enum BU_META {
  HIDE_WERTENTWICKLUNG = 'hidesWertentwicklung',
  EXCLUDE_FROM_REQUEST = 'excludeFromRequest',
}
